/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { UserLoginResponse } from './UserLoginResponse';
const ConfirmRegisteredResponseParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['status', /* #__PURE__ */ parsers.exactly('registered')],
]), UserLoginResponse);
export class ConfirmRegisteredResponse extends UserLoginResponse {
    static decode(input) {
        return ConfirmRegisteredResponseParser.decode(input).map(res => new ConfirmRegisteredResponse(res));
    }
    static unsafeDecode(input) {
        return ConfirmRegisteredResponse.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ConfirmRegisteredResponseParser.encode(data);
    }
    static schema() {
        return ConfirmRegisteredResponseParser.schema();
    }
}
